import { DailyPrintoutGroupingOption } from "../../../utils/models";
import type { ScheduleRow } from "../types";
import { shiftWindowKey } from "../util/shiftTimeFormat";

interface GroupKeyArgs {
	row: ScheduleRow;
	groupingOption: DailyPrintoutGroupingOption;
	jobManagementEnabled: boolean;
}

/**
 * Derive the group key for a single row under a single grouping kind (mapping §6.2).
 *
 * Empty-value rows are bucketed into sentinel groups (`"No Location"`, etc.) rather than dropped
 * (mapping §6.5). For Shift Time this produces the **exact** window key — §6.3's popularity
 * canonicalization runs over these exact keys to fold near-identical windows together.
 */
export const groupKeyFor = ({ row, groupingOption, jobManagementEnabled }: GroupKeyArgs): string => {
	switch (groupingOption) {
		case DailyPrintoutGroupingOption.NONE:
			return "all";
		case DailyPrintoutGroupingOption.LOCATION:
			return row.location || "No Location";
		case DailyPrintoutGroupingOption.ROLE:
			if (jobManagementEnabled) return row.nurse?.jobId || "No Job";
			return row.role || "No Role";
		case DailyPrintoutGroupingOption.FLOOR:
			return row.floor || "No Floor";
		case DailyPrintoutGroupingOption.START_TIME:
			return shiftWindowKey(row.shiftStart, row.shiftEnd);
		case DailyPrintoutGroupingOption.CUSTOM:
			return "Custom";
	}
};
